import { TechniqueFull } from '@omniafishing/core';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useFrontload } from 'react-frontload';
import { LAKE_HERO_TAG } from '../../components/content_list/content_list';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';
import { useUserPreferences } from '../../hooks/use_user_preferences';
import { apiV1 } from '../../lib/api';
import { TechniqueDetail } from './technique_detail';

interface TechniquePageProps {
  technique: TechniqueFull;
}
export const TechniquePage: React.FC<TechniquePageProps> = (props) => {
  const { technique } = props;
  const metaTitle = technique.meta_title || _.startCase(technique.display_name);
  const { setUserPreferencesTechnique } = useUserPreferences();

  useEffect(() => {
    setUserPreferencesTechnique(technique.name);
  }, []);

  const { data } = useFrontload(`TechniquePage:${technique.name}`, async () => {
    const mediaRes = await apiV1.mediaFetch({
      per_page: 5,
      techniques: [technique.name],
      exclude_tags: [LAKE_HERO_TAG],
      order: 'technique',
    });
    return {
      media: mediaRes.data.data,
    };
  });

  return (
    <ScrollToTop>
      <section>
        <SEO titleTemplate="%s" title={metaTitle} description={technique.meta_description}></SEO>

        <TechniqueDetail technique={technique} media={data?.media || []} />
      </section>
    </ScrollToTop>
  );
};

export default TechniquePage;
